import { render, staticRenderFns } from "./CheckBoxManager.vue?vue&type=template&id=5ecababe&scoped=true"
import script from "./CheckBoxManager.vue?vue&type=script&lang=js"
export * from "./CheckBoxManager.vue?vue&type=script&lang=js"
import style0 from "./CheckBoxManager.vue?vue&type=style&index=0&id=5ecababe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecababe",
  null
  
)

export default component.exports